import * as _actions from './actions';
import * as _accessors from './accessors';
import _reducer from './reducer';

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/Feedback/index.js